var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPositionsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5 2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm2-1h2a1 1 0 0 1 1 1H6a1 1 0 0 1 1-1M2 3a1 1 0 0 0-1 1v2h14V4a1 1 0 0 0-1-1zm13 4h-5v2H6V7H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM7 7v1h2V7z",
  clipRule: "evenodd"
})));
export default SvgPositionsIcon;